<template>
  <span v-if="isLoading || hasAlert" class="orcamento-item-alerta">
    <template v-if="!isLoading">
      <i
        :id="'alert' + orcamentoItemId"
        class="fa fa-exclamation-triangle text-danger d-inline orcamento-item-alerta__icon"
      ></i>
      <b-popover
        :target="'alert' + orcamentoItemId"
        triggers="hover"
        placement="topleft"
        container="body"
        boundary="window"
        :fallback-placement="[]"
        offset="8"
        custom-class="orcamento-item-alerta-popover"
      >
        <div class="orcamento-item-alerta-popover__title">{{ popoverTitle }}</div>
        <p v-if="type.price" class="orcamento-item-alerta-popover__text">
          O preço deste produto foi atualizado. Clique em
          <strong class="orcamento-item-alerta-popover__action">Atualizar Produtos</strong>
          para recalcular os valores do orçamento.
        </p>
        <p v-if="type.stock" class="orcamento-item-alerta-popover__text">
          O produto está sem estoque. Por favor o remova antes de prosseguir.
        </p>
        <p v-if="type.priceMin" class="orcamento-item-alerta-popover__text">
          {{ message }}
        </p>
        <p v-if="type.multiple" class="orcamento-item-alerta-popover__text">
          {{ message }}
        </p>
        <p v-if="data == null" class="orcamento-item-alerta-popover__text">
          Não foi possível fazer a consulta de mudanças de produtos, tente
          novamente mais tarde.
        </p>
      </b-popover>
    </template>
  </span>
</template>

<style scoped>
.orcamento-item-alerta {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.orcamento-item-alerta__icon {
  font-size: 0.85rem;
  cursor: help;
  line-height: 1;
}
</style>

<style>
.orcamento-item-alerta-popover.popover {
  background: #fff;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  max-width: 320px;
  z-index: 1080;
}

.orcamento-item-alerta-popover .popover-body {
  padding: 0.85rem 1rem;
  color: #475569;
}

.orcamento-item-alerta-popover.bs-popover-top .arrow::before,
.orcamento-item-alerta-popover.bs-popover-auto[x-placement^="top"] .arrow::before {
  border-top-color: rgba(15, 23, 42, 0.08);
}

.orcamento-item-alerta-popover.bs-popover-top .arrow::after,
.orcamento-item-alerta-popover.bs-popover-auto[x-placement^="top"] .arrow::after {
  border-top-color: #fff;
}

.orcamento-item-alerta-popover__title {
  margin: 0 0 0.35rem;
  color: #0f172a;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.3;
}

.orcamento-item-alerta-popover__text {
  margin: 0;
  color: #64748b;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.45;
}

.orcamento-item-alerta-popover__text + .orcamento-item-alerta-popover__text {
  margin-top: 0.45rem;
}

.orcamento-item-alerta-popover__action {
  color: #2563eb;
  font-weight: 700;
}
</style>

<script>
import Orcamento from "../../../services/orcamento";
import { EventBus } from "../../../helpers/eventBus";

export default {
  name: "OrcamentoItemAlerta",
  props: {
    id: {
      type: String,
      default: "OrcamentoItemAlerta"
    },
    name: {
      type: String,
      default: "OrcamentoItemAlerta"
    },
    orcamentoId: {
      type: Number,
      default: 0
    },
    orcamentoItemId: {
      type: Number,
      default: 0
    },
    alertas: {
      type: Object,
      default: null
    }
  },
  computed: {
    hasAlert() {
      return (this.type.price || this.type.stock || this.type.priceMin || this.type.multiple);
    },
    popoverTitle() {
      if (this.type.price) return "Atenção — Preço Alterado";
      if (this.type.stock) return "Atenção — Sem Estoque";
      if (this.type.priceMin) return "Atenção — Preço Mínimo";
      if (this.type.multiple) return "Atenção — Múltiplo";
      return "Atenção";
    }
  },
  data: () => ({
    isLoading: false,
    data: null,
    message: null,
    type: {
      price: false,
      stock: false,
      priceMin: false,
      multiple: false
    }
  }),
  watch: {
    alertas: {
      deep: true,
      handler(novosAlertas) {
        if (novosAlertas != null) {
          this.aplicarAlertas(novosAlertas);
        }
      }
    }
  },
  mounted() {
    if (this.alertas != null) {
      this.aplicarAlertas(this.alertas);
      return;
    }
    this.getProductItemChangeAlerts(this.orcamentoId, this.orcamentoItemId);
  },
  methods: {
    hasData(value) {
      if (value == null || value === true) return false;
      if (Array.isArray(value)) return value.length > 0;
      return typeof value === "object" && Object.keys(value).length > 0;
    },
    extrairMensagem(value, fallback) {
      if (Array.isArray(value) && value.length > 0) {
        return value[0][0] && value[0][0].mensagem != undefined
          ? value[0][0].mensagem
          : fallback;
      }
      if (!Array.isArray(value) && value && Object.keys(value).length > 0) {
        const key = Object.keys(value)[0];
        return value[key][0] && value[key][0].mensagem != undefined
          ? value[key][0].mensagem
          : fallback;
      }
      return fallback;
    },
    emitirMudancasItem() {
      EventBus.$emit("onBudgetItemHasChanges", {
        orcamento_item_id: this.orcamentoItemId,
        changed: this.hasAlert
      });
    },
    aplicarAlertas(alertas) {
      this.isLoading = false;
      this.data = alertas.mudanca != null ? alertas.mudanca : [];
      this.type.price = this.hasData(alertas.mudanca);
      this.type.stock = this.hasData(alertas.estoque);

      if (this.hasData(alertas.preco_minimo)) {
        this.type.priceMin = true;
        this.message = this.extrairMensagem(
          alertas.preco_minimo,
          "Para esse produto o valor do item está abaixo do mínimo permitido."
        );
      } else {
        this.type.priceMin = false;
      }

      if (this.hasData(alertas.multiplos)) {
        this.type.multiple = true;
        this.message = this.extrairMensagem(
          alertas.multiplos,
          "Verifique o múltiplo deste produto."
        );
      } else {
        this.type.multiple = false;
      }

      this.emitirMudancasItem();
      EventBus.$emit("priceMin", {
        validaPrecoMin: this.type.priceMin
      });
      EventBus.$emit("finishLoad", {
        finish: true
      });
    },
    getProductItemChangeAlerts(orcamento_id, orcamento_item_id) {
      let vue = this;
      this.isLoading = true;
      this.data = null;
      Orcamento.getProductItemChangeAlerts(orcamento_id, orcamento_item_id)
        .then(response => {
          vue.data = response.data.data != null ? response.data.data : [];
          vue.type.price = ( (Array.isArray(vue.data) && vue.data.length > 0) || (!Array.isArray(vue.data) && Object.keys(vue.data).length > 0) );
          vue.emitirMudancasItem();
        })
        .catch(e => {
          if (
            !(
              e.response &&
              e.response.status &&
              e.response.status === 404 &&
              e.response.data
            )
          ) {
            this.$helper.showErrorResponse(e);
          }
        })
        .finally(() => {
          vue.getProductBudgetOutOfStock(orcamento_id, orcamento_item_id);
        });
    },
    getProductBudgetOutOfStock(orcamento_id, orcamento_item_id){
      let vue = this;

       Orcamento.getProductBudgetOutOfStock(orcamento_id, orcamento_item_id)
        .then(response => {
          vue.data = response.data.data;
          vue.type.stock = ( (Array.isArray(vue.data) && vue.data.length > 0) || (!Array.isArray(vue.data) && Object.keys(vue.data).length > 0) );
          vue.emitirMudancasItem();
        })
        .catch(e => {
          if (
            !(
              e.response &&
              e.response.status &&
              e.response.status === 404 &&
              e.response.data
            )
          ) {
            vue.$helper.showErrorResponse(e);
          }
        })
        .finally(() => {
          vue.getProductPriceMinInvalid(orcamento_id, orcamento_item_id);
        });
    },
    getProductPriceMinInvalid(orcamento_id, orcamento_item_id){
      let vue = this;

       Orcamento.getProductBudgetPriceMin(orcamento_id, orcamento_item_id)
        .then(response => {
          vue.data = response.data.data;
          if(Array.isArray(vue.data) && vue.data.length > 0){
            vue.type.priceMin = true;
            vue.message = vue.data[0][0].mensagem != undefined ? vue.data[0][0].mensagem : "Para esse produto o valor do item está abaixo do mínimo permitido.";
          } else if(!Array.isArray(vue.data) && Object.keys(vue.data).length > 0){
            vue.type.priceMin = true;
            vue.message = vue.data[Object.keys(vue.data)][0].mensagem != undefined ? vue.data[Object.keys(vue.data)][0].mensagem : "Para esse produto o valor do item está abaixo do mínimo permitido.";
          } else {
            vue.type.priceMin = false;
            vue.message = null;
          }

          vue.emitirMudancasItem();

          EventBus.$emit("priceMin", {
            validaPrecoMin: vue.type.priceMin
          });
        })
        .catch(e => {
          if (
            !(
              e.response &&
              e.response.status &&
              e.response.status === 404 &&
              e.response.data
            )
          ) {
            vue.$helper.showErrorResponse(e);
          }
        })
        .finally(() => {
          vue.getProductMultiple(orcamento_id, orcamento_item_id);
        });
    },
    getProductMultiple(orcamento_id, orcamento_item_id){
      let vue = this;

      Orcamento.getProductMultiple(orcamento_id, orcamento_item_id)
        .then(response => {
          vue.data = response.data.data;

          if(!Array.isArray(vue.data) && Object.keys(vue.data).length > 0) {
            vue.type.multiple = true;
            vue.message = vue.data[Object.keys(vue.data)][0].mensagem != undefined ? vue.data[Object.keys(vue.data)][0].mensagem : "Verifique o múltiplo deste produto.";
          }
          
          vue.emitirMudancasItem();
        })
        .catch(e => {
          if (
            !(
              e.response &&
              e.response.status &&
              e.response.status === 404 &&
              e.response.data
            )
          ) {
            vue.$helper.showErrorResponse(e);
          }
        })
        .finally(() => {
          vue.isLoading = false;

          EventBus.$emit("finishLoad", {
            finish: true
          });
        });
    }
  }
};
</script>
